// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const managePartnersSelector = createSelector(
    (state): any => state,
    (res: { managePartners: any }) => res.managePartners
);

export const soldToListSelector = createSelector(
    managePartnersSelector,
    res => res.soldToList || []
);

export const shipToListSelector = createSelector(
    managePartnersSelector,
    res => res.shipToList || []
);

export const createSoldToShipToStatusSelector = createSelector(
    managePartnersSelector,
    res => res.soldToShipToCreation || { status: undefined }
);

export const countryListSelector = createSelector(
    (state: any) => state.countries,
    res => res.list
);

export const onSiteSoldToShipToSelector = createSelector(
    managePartnersSelector,
    res => res.onSiteSoldToShipTo
);